import { makeStyles } from '@mui/styles';

const styles = makeStyles(theme => ({
  emptyHealthServiceCardHeight: {
    height: "400px"
  },
  marginTop: {
    marginTop: "20px"
  },
  textCenter: {
    textAlign: "center"
  },
  icon: {
    "& svg": {
      color: "#0000ff"
    }
  },
  medicineList: {
    margin: 0,
    paddingLeft: "20px"
  }
}));
export default styles;